import { render, staticRenderFns } from "./SitePageForm.vue?vue&type=template&id=f3d36af8&"
import script from "./SitePageForm.vue?vue&type=script&lang=js&"
export * from "./SitePageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports